import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mediaTypePipe'
})
export class MediaTypePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value === "VIDEO")
      return "Video";
    if (value === "VIDEO_LIST") {
      return "Video";
    }

    if(value == "HTML" && args != 'VIA' && args.split('_')[0] != 'ACTIVITY') {

      if(args === 'IPJ PRACTICE' || args === 'PRIMER'){
        return "Exercise";
      }
      if(args !== 'IPJ PRACTICE' && args !== 'PRIMER'){
        return "Assessment";
      }
    } else if(args == 'VIA' || args.split('_')[0] == 'ACTIVITY') {
      return 'Activity';
    }
  }

}
